import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { isNative, platform } from '@/lib/platform';

export async function registerFcmToken(uid: string): Promise<void> {
  if (!isNative()) return;
  try {
    const perm = await FirebaseMessaging.checkPermissions();
    if (perm.receive !== 'granted') {
      const req = await FirebaseMessaging.requestPermissions();
      if (req.receive !== 'granted') return;
    }

    const { token } = await FirebaseMessaging.getToken();
    if (!token) return;

    const tokenDocRef = doc(db, `users/${uid}/fcmTokens/${token}`);
    await setDoc(tokenDocRef, {
      token,
      platform: platform(),
      createdAt: serverTimestamp(),
    });

    await FirebaseMessaging.addListener('tokenReceived', ({ token: newToken }) => {
      const ref = doc(db, `users/${uid}/fcmTokens/${newToken}`);
      void setDoc(ref, {
        token: newToken,
        platform: platform(),
        createdAt: serverTimestamp(),
      });
    });
  } catch {
    // non-fatal — push not critical for v1
  }
}
